// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__kJV34","label":"style_label__5IWIB","icon":"style_icon__RicxQ"};